import { render, staticRenderFns } from "./ValidationRuleForm.vue?vue&type=template&id=6ef4b9d6"
import script from "./ValidationRuleForm.vue?vue&type=script&lang=js"
export * from "./ValidationRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports